"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubterraneanReservoir = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var PlaceOceanTile_1 = require("../../deferredActions/PlaceOceanTile");
var CardRenderer_1 = require("../render/CardRenderer");
var SubterraneanReservoir = (function (_super) {
    __extends(SubterraneanReservoir, _super);
    function SubterraneanReservoir() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.SUBTERRANEAN_RESERVOIR,
            cost: 11,
            tr: { oceans: 1 },
            metadata: {
                cardNumber: '127',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.oceans(1);
                }),
                description: 'Place 1 ocean tile.',
            },
        }) || this;
    }
    SubterraneanReservoir.prototype.play = function (player) {
        player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player));
        return undefined;
    };
    return SubterraneanReservoir;
}(Card_1.Card));
exports.SubterraneanReservoir = SubterraneanReservoir;
